import React from 'react';

export const FontStyleItalic = () => (
    <path d='M23.5,0h-8C15.224,0,15,0.224,15,0.5S15.224,1,15.5,1h3.076L4.229,23H0.5C0.224,23,0,23.224,0,23.5S0.224,24,0.5,24h8
		C8.776,24,9,23.776,9,23.5S8.776,23,8.5,23H5.424L19.771,1H23.5C23.776,1,24,0.776,24,0.5S23.776,0,23.5,0z' />
);